/**
 * Handle countries state, fetching a.s.o.
 */
import React from 'react';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import deburr from 'lodash/deburr';

/** Custom import's */
import { Container, Subscribe } from '../../store';
import feathersClient from '../../application/client/app.client';
import { get as getHostUrl } from '../../application/client/hostUrlResolver';

const host = getHostUrl();
const apiClient = feathersClient(host);

/**
 * Keep state handling inside CountriesContainer
 * also fetching data or changing data.
 */
class CountriesContainer extends Container {
  /**
   * Initialize state in constructor - if You like for example fetch
   *
   * EXAMPLE:
   * constructor(props) {
   *   super(props);
   *   this.state = {
   *     countries: props.initialState.countries,
   *   };
   * }
   *
   */
  state = {
    countries: [],
    isFetching: false,
    error: null,
  };

  fetchCountries = (language) => {
    this.setState({ isFetching: true });
    apiClient
      .service('countries')
      .find()
      .then( (result) => {
        const { data } = result;
        const sortedCountries = orderBy(
          data,
          [(country) => deburr(country.name[language])]
        );
        this.setState({
          countries: [...sortedCountries],
          isFetching: false,
        });
      })
      .catch(error => {
        this.setState({ error, isFetching: false });
        console.log('Error occurred: ', error);
      });
  };

  getCountryByCode = (code) => {
    return find(
      this.state.countries,
      (country) => country.twoLetterCode === code);
  }

}

/**
 * Simple HOC for Countries
 *
 * @param {React.Component} Component
 */
const withCountries = (Component) => (props) => {
  return (
    <Subscribe to={CountriesContainer}>
      {(store) => <Component {...store} {...props} />}
    </Subscribe>
  );
};

let countries = new CountriesContainer();

export { countries, withCountries };

export default CountriesContainer;



// WEBPACK FOOTER //
// ./src/containers/CountriesContainer/CountriesContainer.js